import {useTranslation} from "react-i18next";
import DateDisplay from "components/datetime/DateDisplay";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableOrders = ({itemsShow, items, checkAll, setCheckAll, buttonsTB, setButtonsTB, orderingRef, ChoicesStatus, ChoicesOrigin}) => {
    const {t: _Tc} = useTranslation("choices");

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }
        const itemId = Number(e.currentTarget.dataset.idx);

        if (checkbox.checked) {
            items.current.addToChosen(itemId);
        } else {
            items.current.removeFromChosen(itemId);
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => Number(item.id));
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };

    return (
        <table className="table table-striped table-sticky-horizontal">
            <thead>
                <tr>
                    <th style={{...stickyHeaderStyle}} key="-1">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                    <th style={{...stickyHeaderStyle}}>Incidencia</th>
                </tr>
            </thead>
            <tbody>
                {itemsShow.length ? (
                    itemsShow.map((item) => (
                        <tr key={item.id} data-idx={item.id} onClick={onClick}>
                            <td>
                                <input
                                    type="checkbox"
                                    name="checkboxOrder"
                                    key={item.id}
                                    data-idx={item.id}
                                    defaultChecked={Array.isArray(items.current.chosen) ? items.current.chosen.includes(item.id) : false}
                                    readOnly={true}
                                />
                            </td>
                            <td>{item.task_data?.name || '-'}</td>
                            <td>{item.programming_data?.name || '-'}</td>
                            <td>{item.scheduled_at ? <DateDisplay date={item.scheduled_at} format="DD-MM-YYYY HH:mm" title={false} /> : '-'}</td>
                            <td>{ChoicesStatus[item.status] || '-'}</td>
                            <td>{ChoicesOrigin[item.origin] || '-'}</td>
                            <td>{item.created_by_email || '-'}</td>
                            <td>{item.order_leader_email || '-'}</td>
                            <td>{item.incidence_data?.name || '-'}</td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={9}></td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default TableOrders;
